import $store from '@/store';

export const showAlert = (message: string): void => {
    $store.commit('setSnackbar', { text: message });
};

export const showSuccessAlert = (message: string): void => {
    $store.commit('setSnackbar', { text: message, color: 'success' });
};
